import React from "react"

import { joinClasses, changeView, useClasses } from "../globals";

import {
  Box,
  Button,
  Divider,
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// Icons
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"


export const SignUpPartial = ({ firstName, lastName, email }) => {
  const classes = useClasses();

  return (
    <React.Fragment>
      <Box className={classes._Padding}>
        <Box className={classes._Margin}>
          <Alert severity="success">
            Welcome {firstName} {lastName}!
            <br />
            Please sign in to your new account to continue.
          </Alert>
        </Box>
      </Box>

      <Divider />
      <Box className={classes._Padding}>
        <Box className={classes._Margin}>
          <Button
            variant="text"
            fullWidth
            onClick={() => changeView("EmailPasswordLogin", { email })}
            startIcon={<ChevronLeftIcon />}
          >
            Back to Sign In
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  )
}

SignUpPartial.title = "Sign Up Successful"